import styled from "styled-components";

const NumberContainer = styled.span`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

const DecimalPart = styled.span`
  visibility: hidden;
  position: absolute;
  left: 100%;
  background-color: #f9f9f9;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  
  ${NumberContainer}:hover & {
    visibility: visible;
  }
`;

const WholeNumber = styled.span``;

const NumberWithHoverPoints = ({ number }: { number: string | number }) => {
  // Convert to string if it's a number
  const numberString = number.toString();
  
  // Split the number into whole and decimal parts
  const [wholePart, decimalPart] = numberString.split('.');
  
  return (
    <NumberContainer>
      <WholeNumber>{Intl.NumberFormat('en').format(Number(wholePart))}</WholeNumber>
      {decimalPart && (
        <DecimalPart>{decimalPart.slice(0, 4)}/</DecimalPart>
      )}
      ریال
    </NumberContainer>
  );
};

export default NumberWithHoverPoints;